import { render, staticRenderFns } from "./HistorialEntradas.vue?vue&type=template&id=4e72bbc0&"
import script from "./HistorialEntradas.vue?vue&type=script&lang=js&"
export * from "./HistorialEntradas.vue?vue&type=script&lang=js&"
import style0 from "./HistorialEntradas.vue?vue&type=style&index=0&id=4e72bbc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports